var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F15252",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30ZM21 23.5366C21 23.0038 20.5541 22.5732 20.0025 22.5732H19.9925C19.4419 22.5732 19 23.0038 19 23.5366C19 24.0694 19.4509 24.5 20.0025 24.5C20.5541 24.5 21 24.0694 21 23.5366ZM20.7408 16.2226C20.7408 15.8237 20.4057 15.5 19.9927 15.5C19.5798 15.5 19.2446 15.8237 19.2446 16.2226V20.4798C19.2446 20.8787 19.5798 21.2024 19.9927 21.2024C20.4057 21.2024 20.7408 20.8787 20.7408 20.4798V16.2226Z",
    fill: "#F15252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToastIcon);
export default __webpack_public_path__ + "static/media/error-toast-icon.e43cf0a6cf1a0dadb4f55956a451c22e.svg";
export { ForwardRef as ReactComponent };